interface Props {
  diameter: number;
}

export default function Labels({ diameter }: Props) {
  const dotSize = diameter * 0.075;
  const fontSize = diameter * 0.2;

  return (
    <div className="select-none">
      <div
        className="pointer-events-none absolute inset-0 origin-center rotate-[60deg] scale-[150%]"
        style={{ width: diameter, height: diameter }}
      >
        <div
          className="absolute left-1/2 top-0 rounded-full bg-slate-300 bg-opacity-50"
          style={{ width: dotSize, height: dotSize }}
        />
      </div>

      <div
        className="pointer-events-none absolute inset-0 origin-center -rotate-[70deg] scale-[150%]"
        style={{ width: diameter, height: diameter }}
      >
        <div
          className="-1 absolute left-1/2 top-0 rounded-full bg-slate-300 bg-opacity-50"
          style={{ width: dotSize, height: dotSize }}
        />
      </div>

      <div
        className="absolute -top-0 left-1/2 flex -translate-x-1/2 -translate-y-[125%] items-center justify-center rounded-full text-slate-300"
        style={{ fontSize }}
      >
        C
      </div>

      <div
        className="absolute -bottom-1/2 -left-0 flex -translate-x-1/2 -translate-y-[125%] items-center justify-center rounded-full text-slate-300"
        style={{ fontSize }}
      >
        L
      </div>

      <div
        className="absolute -bottom-1/2 -right-0 flex -translate-y-[125%] translate-x-1/2 items-center justify-center rounded-full text-slate-300"
        style={{ fontSize }}
      >
        R
      </div>
    </div>
  );
}
